// ----------------------------------------------------------------------

const account = {
  displayName: sessionStorage.getItem('loggedUer'),
  email: sessionStorage.getItem('loggedUer'),
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
